import { useMemo } from "react";
import { useApiConfig } from "common-fe";
import { Configuration, OrganizationMemberApi } from "account-common";

// account-common API clients for scoreadmin (member list for the scribe-assignment
// pick-lists). Same token + X-Org-Id wiring as scoreApi.js via common-fe's
// useApiConfig. Base URL from VITE_ACCOUNT_API_BASE_URL (the org list + members
// are served by the ACCOUNT API — see manager-fe's org switcher).
const ACCOUNT_API_BASE_URL = import.meta.env.VITE_ACCOUNT_API_BASE_URL;

export function useAccountApi() {
  const buildConfig = useApiConfig();
  return useMemo(() => {
    const config = new Configuration(buildConfig(ACCOUNT_API_BASE_URL));
    return { org: new OrganizationMemberApi(config) };
  }, [buildConfig]);
}
